import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

export const StyledShowMoreButton = styled(Button)`
  background-color: transparent;
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
  line-height: 20px;
`;
